import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import ViewTerminalFiles from "../../components/ViewTerminalFiles/ViewTerminalFiles";
import Layout from "../../components/shared/Layout/Layout";

const ViewTerminalFilePage = ({ grades, getGradeList }) => {
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`Terminal Assessment`}>
        <ViewTerminalFiles grades={grades} />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(ViewTerminalFilePage);
